import { Store } from '../codegen/graphql';

export interface StoreOption {
    value: string;
    label: string;
    disabled?: boolean;
}

export const mapStoreToManagerOption = (
    store: Store,
    isAdmin: boolean = false,
): StoreOption => {
    const hasMaxManagers = (store.managers?.length || 0) >= 2;
    const baseLabel =
        [store.storeNo, store.name].filter(Boolean).join(' - ') || 'N/A';

    let label = baseLabel;
    if (hasMaxManagers) {
        label = `${label} (${
            isAdmin
                ? 'Already has 2 managers - Admin override available'
                : 'Maximum managers reached'
        })`;
    }

    return {
        value: store.id,
        label,
        disabled: hasMaxManagers && !isAdmin,
    };
};
